import {
	IconSocialFacebook,
	IconSocialInstagram,
	IconSocialPinterest,
	IconSocialTikTok,
	IconSocialTwitter,
} from "assets/img/icons";
import { SOCIAL_NETWORK_URL } from "./common";

const EMAIL_OPT_IN = {
	NOT_ADD_USER: {
		name: "NOT_ADD_USER",
		method: "",
	},
	OPT_IN_AUTOMATICALLY: {
		name: "OPT_IN_AUTOMATICALLY",
		method: "Form Submission without consent",
	},
	OPT_IN_SUBMISSION: {
		name: "OPT_IN_SUBMISSION",
		method: "Passive consent",
	},
	ASK_USER: {
		name: "ASK_USER",
		method: "Active consent",
	},
	FIELD_NAME: "creatorOptInEmail",
};

const EMAIL_OPT_IN_FIELD_VALUES = [EMAIL_OPT_IN.OPT_IN_SUBMISSION.name, EMAIL_OPT_IN.ASK_USER.name];

const CLIENT_NAME = "{{Client Name}}";

const GOOGLE_PICKER = {
	SCOPES: "https://www.googleapis.com/auth/drive.readonly",
	PHOTOS_SCOPES: "https://www.googleapis.com/auth/photospicker.mediaitems.readonly",
	ACTION: {
		PICKED: "picked",
	},
};

const GOOGLE = {
	OAUTH_SCRIPT: "https://apis.google.com/js/api.js",
	GIS_SCRIPT: "https://accounts.google.com/gsi/client",
	VALIDATE_ACCESS_TOKEN_API: "https://oauth2.googleapis.com/tokeninfo?access_token=",
	YOUTUBE_READONLY_SCOPE: "https://www.googleapis.com/auth/youtube.readonly",
	PHOTOS_PICKER_SESSION_API: "https://photospicker.googleapis.com/v1/sessions",
	PHOTOS_PICKER_MEDIA_ITEMS_API: "https://photospicker.googleapis.com/v1/mediaItems",
};

const YOUTUBE_UPLOADING = {
	MAX_RESULTS: 50,
	PART: "snippet,contentDetails,status",
	STATUS_PRIVACY: {
		PUBLIC: "public",
		PRIVATE: "private",
	},
};

const FONT_FAMILY = {
	GOOGLE_SANS_TEXT: "Google Sans Text",
	GOOGLE_SANS: "Google Sans",
};

const MAX_FILE_SIZE = {
	BYTE: 5368709120,
	MB: 42000, // converted from 5368709120
};

const DEFAULT_WIDGET_SETTINGS = {
	maxFileSize: 300,
	maxVideoPerUpload: 3,
	maxPhotoPerUpload: 20,
	maxVideoLength: 600,
	isNewFlow: true,
};

const WIDGET_GALLERY_POSITION = {
	ABOVE: "ABOVE",
	BELOW: "BELOW",
	HIDE: "HIDE",
};

const WIDGET_GALLERY_TYPE = {
	STATIC: "STATIC",
	ANIMATED: "ANIMATED",
};

const DEFAULT_GOOGLE_DRIVE_REQUEST_DATA = {
	selectedMediaList: [],
	accessToken: "",
};

const SOCIAL_NETWORK_LIST = [
	{
		id: 1,
		icon: <IconSocialInstagram />,
		href: SOCIAL_NETWORK_URL.INSTAGRAM,
	},
	{
		id: 2,
		icon: <IconSocialTikTok />,
		href: SOCIAL_NETWORK_URL.TIKTOK,
	},
	{
		id: 3,
		icon: <IconSocialTwitter />,
		href: SOCIAL_NETWORK_URL.TWITTER,
	},
	{
		id: 4,
		icon: <IconSocialFacebook />,
		href: SOCIAL_NETWORK_URL.FACEBOOK,
	},
	{
		id: 5,
		icon: <IconSocialPinterest />,
		href: SOCIAL_NETWORK_URL.PINTEREST,
	},
];

const WIDGET_FORM_STATE = {
	UPLOAD_CONFIRMATION: "UPLOAD_CONFIRMATION",
};

export {
	EMAIL_OPT_IN,
	EMAIL_OPT_IN_FIELD_VALUES,
	CLIENT_NAME,
	GOOGLE_PICKER,
	GOOGLE,
	YOUTUBE_UPLOADING,
	FONT_FAMILY,
	MAX_FILE_SIZE,
	DEFAULT_WIDGET_SETTINGS,
	WIDGET_GALLERY_POSITION,
	WIDGET_GALLERY_TYPE,
	DEFAULT_GOOGLE_DRIVE_REQUEST_DATA,
	SOCIAL_NETWORK_LIST,
	WIDGET_FORM_STATE,
};
